import { render, staticRenderFns } from "./digitalInfrastructure.vue?vue&type=template&id=7dd37252&scoped=true&"
import script from "./digitalInfrastructure.vue?vue&type=script&lang=js&"
export * from "./digitalInfrastructure.vue?vue&type=script&lang=js&"
import style0 from "./digitalInfrastructure.vue?vue&type=style&index=0&id=7dd37252&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd37252",
  null
  
)

export default component.exports